<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/manage-assessments']" [queryParams]="{tab:tab}"><img
            src="assets/images/admin/backarrow.png" /> Back to Manage Assessment</a>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="centerWrap mt-4 pt-2">
    <div class="adminInnerHead pt-2">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="userCouresLatest pb-2">
                    <div class="userCouresContent">
                        <h3>{{assessmentDetails?.assessment_name}}</h3>
                      <p>
                            <span>Created by: {{assessmentDetails?.created_by}} on
                                {{assessmentDetails?.created_dttm | date:'d MMM, y'}}</span>
                        </p>
                        <div class="chartrow d-flex align-items-center">
                            <b> <img src="assets/images/icons/frame.svg" /> </b>
                            <p class="pl-2">{{assessmentDetails?.total_questions}} Questions</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="courseTabs">
                    <p>{{assessmentDetails?.course_desc}}</p>
                    <ul class="customTab">
                        <li><a href="javascript:void(0);" [routerLink]="['/view-assessment']"
                                [queryParams]="{id:assessment_id,tab:tab}">VIEW</a> </li>

                        <!-- <li><a href="javascript:void(0);" [routerLink]="['/courses_view_user']"
                                [queryParams]="{id:assessment_id,tab:tab}">VIEW USERS</a> </li> -->
                        <li *ngIf="assessmentDetails?.is_active==1"><a href="javascript:void(0);" class="active"
                                [routerLink]="['/view-user']"
                                [queryParams]="{id:assessment_id,tab:tab}">ASSIGNED TO
                                (USERS)</a> </li>
                        <li *ngIf="assessmentDetails?.is_active==1"><a href="javascript:void(0);"
                                [routerLink]="['/assign-users']"
                                [queryParams]="{id:assessment_id,tab:tab}">ASSIGN USERS</a> </li>
                        <li *ngIf="assessmentDetails?.assigned_users==0"><a href="javascript:void(0);" [routerLink]="['/create-assessment']"
                                [queryParams]="{assId:assessment_id,tab:tab}" >EDIT</a> </li>
                        <li><a href="javascript:void(0);" (click)="open(duplicate)">DUPLICATE</a> </li>
                        <li class="deactiveTab" *ngIf="assessmentDetails?.is_active==1"><a href="javascript:void(0);"
                                (click)="open(deactivate)">DEACTIVATE</a> </li>
                        <li class="deactiveTab" *ngIf="assessmentDetails?.is_active==0"><a href="javascript:void(0);"
                                (click)="open(activate)">ACTIVATE</a> </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="numberOfUsers" *ngIf="viewUsersDetail">
        <ul>
            <li>
                <div class="showUsers">
                    <h3>{{viewUsersDetail[0]?.total_user}} total Users</h3>
                </div>
            </li>
            <li>
                <div class="showUsers green">
                    <b><i></i>{{viewUsersDetail[0]?.total_complete}}</b>
                    <span>Assigment Completed</span>
                </div>
            </li>
          
            <li>
                <div class="showUsers red">
                    <b><i></i>{{viewUsersDetail[0]?.total_notstart}}</b>
                    <span>Assignment not Started</span>
                </div>
            </li>
        </ul>
    </div>
    <div class="formHeading pr-0">
        <div class="row m-0">
            <div class="col-12 col-md-4">
                <h2>Assign Assessment</h2>
                <p>Select 1 or more assessment from the list to assign to this user. </p>
            </div>
            <div class="col-12 col-md-4">
                <div class="filterWrap">
                    <div class="searchWrap mr-0">
                        <input type="text" placeholder="Search Users" (keyup)="search($event)">
                    </div>
                </div>
            </div>

        </div>
    </div>


    <div class="tableWrap">
        <table matSort (matSortChange)="sortData($event)">
            <thead>
                <tr>
                    <th>
                        <div mat-sort-header="first_name"><b></b> User Name</div>
                    </th>
                    <th>Status</th>
                    <th>Time<br />Spent</th>
                    <th>No. of Attempts</th>
                    <th>
                        <div class="reset_requestTh">Assessment<br />Reset Request <b><img
                                    src="assets/images/admin/frame_red.png" /></b></div>
                    </th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody *ngIf="viewUsersDetail">
                <tr *ngFor="let values of viewUsersDetail;let i = index">
                    <td>
                        <div class="courseTdWrap">
                            <!-- <a href="javascript:void(0);">{{values.first_name}} {{values.last_name}}</a><br> -->
                            <span>{{values.user_name}}</span><br>
                            <b>{{values.email}}</b><br>
                            <b>Assigned on {{values.created_dttm | date:'d MMM, y'}}</b>
                        </div>
                    </td>
                    <td>
                        <span *ngIf="values.status == 1" class="statusTd red">Not Started</span>
                        <span *ngIf="values.status == 2" class="ongoing">ongoing</span>
                        <span *ngIf="values.status == 3 " class="red">Completed</span>
                        <span class="d-block" *ngIf="values.status != 1">Started on {{values.course_start_dttm | date:'d MMM, y'}}</span>
                        <span class="d-block" *ngIf="values.status != 1">Last viewed on {{values.last_login | date:'d MMM,
                            y'}}</span>
                    </td>
                    <td>0 hr {{values.time_spent + 1}} min</td>
                    <td class="text-center">{{values.attempt_num == null ? 0 : values.attempt_num}}/3</td>
                    <!-- <td>{{values.no_of_assessments_passed}}</td> -->
                    <td>
                        <span style="text-align: center;"
                            *ngIf="values.admin_request ==null && values.is_passed ==null &&values.reset_request==null">N/A</span>
                        <div class="moduleWrap" *ngIf="values.assessment_id && values.admin_request ==1 && values.status !=5">
                            <div class="moduleChoues">
                                <a href="javascript:void(0);" class="moduleList mr-3"
                                    (click)="openAccept(AcceptContent, values)">
                                    <i><img src="assets/images/admin/done.png" /></i>Accept
                                </a>
                                <a href="javascript:void(0);" class="moduleList"
                                    (click)="openReject(RejectContent, values)">
                                    <i><img src="assets/images/admin/close_big.png" /></i>Reject
                                </a>
                            </div>
                        </div>
                        <div *ngIf="values.status==5 && values.reset_request==0">
                            <span style="text-align: center;">Rejected</span>
                        </div>
                        <div *ngIf="values.status==1 && values.admin_request ==null && values.reset_request==1">
                            <span style="text-align: center;">Accepted</span>
                        </div>
                    </td>
                   
                    <td>
                        <ul class="userActionBtn">
                            <li *ngIf="values.status!=3"><a href="javascript:void(0);"
                                    (click)="opens(deassign,values.user_id)" class="btn-link">DEASSIGN</a></li>
                            <li *ngIf="values.status == 3">
                                <a style="cursor: pointer; color: green;" (click)="downloadAssmntCerti(values)">Download Certificate</a>
                            </li>
                        </ul>
                    
                    </td>
                </tr>


            </tbody>
        </table>
    </div>
</div>
<ng-template #deassign let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Deassign User</h6>
                <p class="size18">Are you sure you want to deassign this user?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="DeAssignUser(userID)">Yes,
                    DeAssign</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #deactivate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>DeActivate course</h6>
                <p class="size18">Are you sure you want to deactivate this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="changeIsDeActiveVal(0)">Yes,
                    DeActivate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #activate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Activate course</h6>
                <p class="size18">Are you sure you want to activate this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="changeIsDeActiveVal(1)">Yes,
                    Activate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #duplicate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Duplicate course</h6>
                <p class="size18">Are you sure you want to duplicate this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="duplicateCourse()">Yes,
                    Duplicate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #AcceptContent let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close"
                (click)="modal.dismiss('Cross click'); this.viewAsmntAssignedUsers(this.assessment_id, this.searchText, this.order, this.order_by, this.filter_by_org);">
                <span aria-hidden="true">&times;</span>
            </button>
            <h6>Accept Reset Request</h6>
            <p>You have approved the reset request.</p>

            <a href="javascript:void(0);" class="backPage ml-2 mr-2"
                (click)="modal.close('Close click'); this.viewAsmntAssignedUsers(this.assessment_id, this.searchText, this.order, this.order_by, this.filter_by_org);">
                <span>Close</span>
            </a>
        </div>
    </div>
</ng-template>

<ng-template #RejectContent let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close"
                (click)="modal.dismiss('Cross click'); this.viewAsmntAssignedUsers(this.assessment_id, this.searchText, this.order, this.order_by, this.filter_by_org);">
                <span aria-hidden="true">&times;</span>
            </button>
            <h6>Reject Reset Request</h6>

            <!-- <form [formGroup]="rejectForm">
                <div class="commanInput">
                    <mat-form-field class="example-full-width">
                        <mat-label>Remark</mat-label>
                        <input matInput formControlName="txtRemark" [ngClass]="{ 'is-invalid': submitted && f.txtRemark.errors }" autocomplete="off">
                    </mat-form-field> 
                    <div *ngIf="submitted && f.txtRemark.errors">
                        <span *ngIf="f.txtRemark.errors.required" class="text-mute text-danger errorText">This field is required</span>
                    </div>
                </div>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border" (click)="modal.close('Close click')"> <span>Close</span>
                </a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-2 mr-2" (click)="onSubmit(rejectForm.value)">Submit</a>
              </form> -->
            <p>You have rejected the reset request.</p>

            <a href="javascript:void(0);" class="backPage ml-2 mr-2"
                (click)="modal.close('Close click'); this.viewAsmntAssignedUsers(this.assessment_id, this.searchText, this.order, this.order_by, this.filter_by_org);">
                <span>Close</span>
            </a>

        </div>
    </div>
</ng-template>